module.exports = __webpack_public_path__ + "img/into-the-light.979670f5.jpg";